export default __webpack_public_path__ + "static/media/LogoAppNegative.e990d8d0.png";